import React from 'react'
import moment from 'moment'

import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom'

import { connect } from 'react-redux'

import { withPreviousDate, getPurposes, getFilterCount } from './reducer'
import { onOpenChange, updateRange, selectFilter, clearFilters,
  selectPlaceFilter,
  selectVehicleFilter,
} from './actions'
import Filter from '../core/Filter'


const mapStateToProps = ({trips, models}, ownProps)=>({
  ...trips,
  filterCount: getFilterCount(trips.filterValues),
  favoritePlaces: models.places,
  institutionUsers: models.user.institution_users,
  trips: withPreviousDate(models.trips),
  purposes: getPurposes({models}),
  vehicles: models.vehicles
})


export default connect(mapStateToProps, {
  // actionCreators:
  onOpenChange,
  updateRange, selectFilter, clearFilters,
  // trip specific:
  selectPlaceFilter,
  selectVehicleFilter,
  // txn specific:
  // selectFiltertripType, selectFilterInstitutionAccountName
})(Filter)



// WEBPACK FOOTER //
// ./src/trips/Filter.js